import r from "./helpers/componentAvailabilityRegistry.js";
import e from "../sessionReady.js";
import { boolOrFalse as n } from "../../../../../utils/value/bool.js";
const p = async (i, o) => {
  var t, a;
  return await e(o), n(await ((a = (t = r)[i]) == null ? void 0 : a.call(t, o.context)));
};
export {
  p as default
};
